<template>
    <b-form-group>
        <label for="" v-if="!!label">{{label}} <span class="required-mark" v-if="required">*</span></label>
        <b-form-input
            type="date"
            v-bind="$attrs"
            v-on="$listeners"
        ></b-form-input>
        <span class="field-error" v-if="hasError">
            {{errorMessage}}
        </span>
    </b-form-group>
</template>
<script>
export default {
    inheritAttrs: false,
    props: {
        label: {
            type: String,
            default: ''
        },
        required: {
            type: Boolean,
            default: () => false
        },
        errorMessage: {
            type: String,
            default: ''
        },
        hasError: {
            type: Boolean,
            default: () => false
        }
    }
}
</script>